/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Resolve_Section_TitleInputs */

const vi_trip_resolve_section_title = /** @type {(inputs: Trip_Resolve_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đang giao cần xử lý`)
};

/**

* @param {Trip_Resolve_Section_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_resolve_section_title = /** @type {((inputs?: Trip_Resolve_Section_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Resolve_Section_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_resolve_section_title(inputs)
});